// import React from 'react'
// import InnerPageHero from '../components/sections/InnerPageHero'
// import { FaHome } from 'react-icons/fa';
// import GetInTouch from '../components/sections/GetInTouch';
// import BloG from '../components/sections/BloG';
// import LogoGenerator from '../components/sections/LogoGenerator';

// function Blog() {
//   return (
//     <div className="app-container">
//     <InnerPageHero 
//      title="Blog"
//      breadcrumbs={[
//        { label: 'Home', href: '/', icon: FaHome },
//        { label: 'Blog', isCurrentPage: true }
//      ]}
//       />
//       <BloG />
//       {/* <LogoGenerator /> */}
//     <GetInTouch />
//   </div>
//   )
// }

// export default Blog

// src/pages/Blog.js
import React from 'react';
import { Box, Container, Grid } from '@chakra-ui/react';
import BlogPostCard from '../components/BlogPostCard';
import { FaHome } from 'react-icons/fa';
import usePosts from '../hooks/usePosts';
import InnerPageHero from '../components/sections/InnerPageHero';

const Blog = () => {
  const { posts, loading } = usePosts();

  if (loading) return <div class="loader"></div>;

  return (
    <Box py={8}>
        <InnerPageHero 
     title="Blogs"
     breadcrumbs={[
       { label: 'Home', href: '/', icon: FaHome },
       { label: 'Blog', isCurrentPage: true }
     ]}
      />
      <Container maxW="container.xl" mt={10}>
        <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6}>
          {posts.map(post => (
            <BlogPostCard key={post.id} post={post} />
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Blog;